import { useState } from 'react';
import useSync from 'hooks/useSync';

import CommonButton from 'components/CommonButton/CommonButton';
import axiosInstance from 'apis/axiosInstance';
import SyncStatus from '../../SyncStatus/SynStatus';
import { SYNC_STATUS, ROLE } from 'utils/constants';
import LatestSyncMessage from '../LatestSyncMessage/LatestSyncMessage';
import { renderToast } from 'components/Toast/Toast';
import getIsSyncDisabled from 'pages/SyncPage/util/getIsSyncDisabled';
import { useUser } from 'context/userContext';
import InfoTooltip from 'pages/SyncPage/InfoTooltip/InfoTooltip';

const OperatorySection = () => {
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const { user } = useUser();

  const { data, isLoading, mutate } = useSync();

  const isSyncDisabled = getIsSyncDisabled(
    data?.operatory,
    user.adminRole?.role === ROLE.GLOBAL_ADMIN
  );

  const handleUpdateOperatory = async () => {
    setIsButtonLoading(true);
    try {
      const response = await axiosInstance.get('/sync/operatories');
      renderToast({
        message: `Successfully obtained ${response.data.length} operatories`,
        type: 'success',
      });
    } catch (error) {
      renderToast({
        message: 'An error has occurred. Please try again.',
        type: 'error',
      });
    }
    await mutate();
    setIsButtonLoading(false);
  };

  return (
    <div className="py-2 border-b border-light-grey">
      <div className="flex justify-between">
        <div className="basis-[45rem]">
          <div className="flex gap-x-0.9">
            <h3 className="font-bold">
              Get latest operatories list from the Connector
            </h3>
            <InfoTooltip id={'operatory'} display={isSyncDisabled} />
          </div>
          <p className="mt-2">
            Click the Update button to get the latest list of operatories from
            the Connector
          </p>
        </div>
        <div className="flex flex-col items-end">
          <CommonButton
            variant="secondary"
            className="!min-h-[3.2rem]"
            onClick={handleUpdateOperatory}
            isLoading={isButtonLoading}
            disabled={
              data?.operatory?.status === SYNC_STATUS.IN_PROGRESS ||
              isLoading ||
              isSyncDisabled
            }
          >
            Update
          </CommonButton>
        </div>
      </div>
      <div className="flex flex-col gap-y-0.8 mt-2">
        <SyncStatus
          isLoading={isLoading}
          data={{
            ...data?.operatory,
            status: isButtonLoading
              ? SYNC_STATUS.IN_PROGRESS
              : data?.operatory?.status,
          }}
        />
        <LatestSyncMessage
          isLoading={isLoading}
          lastSyncAt={data?.operatory?.lastSyncAt}
          lastSuccessSyncAt={data?.operatory?.lastSuccessSyncAt}
          isUpdateMessage
        />
      </div>
    </div>
  );
};

export default OperatorySection;
